module.exports = __webpack_public_path__ + "static/img/beautiful.1d266ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beautiful.png
// module id = cUQL
// module chunks = 1